// extracted by mini-css-extract-plugin
export default {"wrapper":"LAPiiOwXTXJp9mwn092f","subtle":"WPyZ7mUlbfA1LkEtQsQl","wrapperDown":"mZEXWvb87fn_s05whWQQ","icon":"KiqhQSBaTSbBWyh7oFKa","label":"p0JTrp0C9ACjIkUfoGPj"};